// eslint-disable-next-line import/no-anonymous-default-export
export default {
  try: '₺ Türk Lirası',
  usd: '$ Dolar',
  eur: '€ Euro',
  gbp: '£ Sterlin',
  gold: 'Altın'
};
